import { JsonModel, Model } from './model'

export class SupplierCollectionsRow extends Model {
    assignedUser: number
    balance: number
    supplierId: number
    supplierName: string
    supplierPhone: string
    hasRecentlyPaid: boolean
    substatus: { code: number; name: string } | null

    constructor(json: JsonSupplierCollectionsRow) {
        super(json)

        this.assignedUser = json.assignedUser
        this.balance = json.balance
        this.supplierId = json.supplierId
        this.supplierName = json.supplierName
        this.supplierPhone = json.supplierPhone
        this.hasRecentlyPaid = json.hasRecentlyPaid ?? false
        this.substatus = json.substatus ?? null
    }
}

export interface JsonSupplierCollectionsRow extends JsonModel {
    assignedUser: number
    balance: number
    supplierId: number
    supplierName: string
    supplierPhone: string
    hasRecentlyPaid?: boolean
    substatus?: { code: number; name: string } | null
}
